import { Page } from "@/components/page";
import { Space, Title } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_subscribed/_main/game-generator",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page title="Game Generator">
      <Title mb="lg">Game Generator</Title>
      <Outlet />
      <Space mb="xl" />
    </Page>
  );
}
